import { Box, Grid } from "@mui/material";
// eslint-disable-next-line no-restricted-imports
import { InlineError, Typography } from "@pmag/ui-components";
import { Routes } from "@src/context/router/RouterContext";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { useRouter } from "@src/hooks/useRouter";
import { useSupportedBrands } from "@src/hooks/useSupportedBrands";
import { BrandSelectionSkeleton } from "@src/pages/landingPage/components/brandSelection/BrandSelectionSkeleton";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

import { Card, StyledImage } from "./BrandSelection.styles";

export const dataTestId = {
    container: "sparePartsFinder.landingPage.brandSelection.container",
    loadingSkeleton: "sparePartsFinder.landingPage.brandSelection.loadingSkeleton",
    inlineError: "sparePartsFinder.landingPage.brandSelection.inlineError",
    card: "sparePartsFinder.landingPage.brandSelection.card",
};

export const BrandSelection: FunctionComponent = () => {
    const { setRoute } = useRouter();
    const { setBrandId, setBreadcrumbs } = useGlobalState();

    const { supportedBrands, loading, error } = useSupportedBrands();

    if (error) return <InlineError data-testid={dataTestId.inlineError} />;

    return (
        <Box data-testid={dataTestId.container} mb={8}>
            <Box mb={3}>
                <Typography variant="label-02">
                    <FormattedMessage id="sparePartsFinder.landingPage.brandSelection.title" defaultMessage="or select your brand" />
                </Typography>
            </Box>

            {supportedBrands.length > 0 ? (
                <Grid
                    container
                    columns={{
                        lg: 12,
                        md: 12,
                        sm: 8,
                        xl: 12,
                        xs: 4,
                    }}
                    spacing={3}
                >
                    {supportedBrands.map((item, index) => (
                        <Grid item xs={8} sm={4} md={6} lg={4} xl={3} key={`logo-${index}`}>
                            <Card
                                onClick={() => {
                                    setBrandId(item.id);
                                    setBreadcrumbs([{ categoryId: item.id, description: item.name }]);
                                    setRoute(Routes.VisualSelector);
                                }}
                                hoverUrl={item.logoTransparentPath}
                                hoverBackground={item.logoTransparentBackgroundColor}
                                data-testid={dataTestId.card}
                            >
                                {item.logoGrayscalePath && <StyledImage url={item.logoGrayscalePath} />}
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                loading && <BrandSelectionSkeleton data-testid={dataTestId.loadingSkeleton} />
            )}
        </Box>
    );
};
